import axios from "@/plugins/axios";

let url = "/api/v1/person/employment/contracts"

export default {
    gets(data) {      
        return axios.get(url, data).then((result) => result.data);
    },
    get(data) {
        return axios.get(`${url}/${data._id}`).then((result) => result.data);
    },
    post(data) {
        return axios.post(url, data).then((result) => result.data);
    },
    put(data) {
        return axios.put(`${url}/${data._id}`, data).then((result) => result.data);
    },
    upload:{
        post( { _signForm, type } , file) {
            var headers = { "Content-Type": "multipart/form-data" };
            var formData = new FormData();
            if (_signForm) formData.append("_signForm", _signForm);
            if (type !== undefined) formData.append("type", type);
            formData.append("file", file);
            return axios.post(`${url}/${_signForm}/upload`, formData, { headers }).then((result) => result.data);
        },
    }
};
